// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";
// import XmasTreeIcon from "../assets/winter/tree-icon.png";
import AppCard from "../components/appCard";
class RightAppCard extends React.Component {
  constructor(props) {
    super(props);
  }
  // componentDidMount() {}

  render() {
    const { t } = this.props;
    const filterItems = this.props.items.filter((item) => item.visible);
    let rightCardBody;
    if (filterItems.length > 0) {
      if (filterItems.every((item) => !item.visible)) {
        rightCardBody = (
          <h1 className="text-3xl text-center text-slate-400">
            {t("app_card.no_result")}
          </h1>
        );
      }
      const appCardList = filterItems.map((item) => {
        return (
          <AppCard
            key={item.id}
            name={item.name}
            id={item.id}
            system_url={item.system_url}
            description={item.description}
            enable={item.sso_login}
          ></AppCard>
        );
      });
      rightCardBody = (
        <div className="grid px-1 grid-rows-3 grid-flow-row grid-flow-row sm:grid-flow-row md:grid-flow-row sm:grid-cols-3 md:grid-clos-3 grid-clos-1 gap-x-2 sm:gap-x-3 md:gap-x-4 lg:gap-x-5 items-end">
          {appCardList}
        </div>
      );
    }
    return (
      <>
        <div className="w-100  p-4 rounded-xl   h-100">
          <div className="mb-4 flex justify-start justify-items-end">
            {/* <span className="">
              <img className="w-8" src={XmasTreeIcon}></img>
            </span> */}
            <h3 className=" pl-5  text-2xl  font-medium text-gray-600 tracking-widest text-sky-500 ">
              {t("profile_card.topic_current")}
            </h3>
          </div>

          {rightCardBody}
          {/* <div className="ribbonWrapper">
            <div className="ribbon">
              <a
                href="javascript:void(0);"
                className="cursor-default"
              >
                { this.props.season === "Spring" ? "Bless of Spring" :
                    this.props.season === "Summer" ? "High Summer" :
                      this.props.season === "Autumn" ? "Happy ECV Birthday" :
                        this.props.season === "Winter" ? "Happy New Year" : null}
              </a>
            </div>
          </div> */}
          { this.props.seasonThemeImg && <img src={require(`../assets/${this.props.seasonThemeImg}.png`)} alt="seasonThemeImg" className="seasonThemeImgWidth ml-auto fixed bottom-0 right-1 z-10" />}
        </div>
      </>
    );
  }
}

RightAppCard.propTypes = {
  t: PropTypes.any.isRequired,
  i18n: PropTypes.any.isRequired,
  items: PropTypes.array.isRequired,
  season: PropTypes.string,
  seasonThemeImg: PropTypes.string
  // itemArr: PropTypes.object
};

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

// export default rightAppCard;
export default withTranslation()(RightAppCard);
